// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const DownloadIcon = props => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.984 3.986A1 1 0 0011 5v7.586l-2.29-2.297a1.004 1.004 0 10-1.42 1.422l4 4A1 1 0 0012 16a1 1 0 00.71-.29l4-4a1.004 1.004 0 00-1.42-1.42L13 12.585V5a1 1 0 00-1.016-1.014zm-9 10A1 1 0 002 15v4a1 1 0 001 1h18a1 1 0 001-1v-4a1 1 0 10-2 0v3H4v-3a1 1 0 00-1.016-1.014z" fill="currentColor"/></svg>'} />;

DownloadIcon.displayName = 'DownloadIcon';

export default DownloadIcon;
